export interface AddressLike {
    address1?: string | null;
    address2?: string | null;
    area?: string | null;
    taluka?: string | null;
    district?: string | null;
    state?: string | null;
    country?: string | null;
    pincode?: string | null;
    isPermanent?: boolean | null;
}

export interface PatientAddressLike {
    address?: AddressLike[] | null;
}

export class AddressUtils {
    private static readonly addressFields: (keyof AddressLike)[] = [
        'address1',
        'address2',
        'area',
        'taluka',
        'district',
        'state',
        'country',
        'pincode'
    ];

    static getPreferredAddress(addresses?: AddressLike[] | null): AddressLike | undefined {
        if (!addresses?.length) {
            return undefined;
        }

        return addresses.find(address => address?.isPermanent === true) || addresses[0];
    }

    static formatFullAddress(address?: AddressLike | null): string {
        if (!address) {
            return '';
        }

        return this.addressFields
            .map(field => address[field]?.toString().trim())
            .filter((part): part is string => !!part && part !== '-')
            .join(', ');
    }

    static formatPatientAddress(patientOrAddresses?: PatientAddressLike | AddressLike[] | null): string {
        const addresses = Array.isArray(patientOrAddresses)
            ? patientOrAddresses
            : patientOrAddresses?.address;

        return this.formatFullAddress(this.getPreferredAddress(addresses));
    }
}
